export const WITHDRAW_TRANSACTION_TYPES = {
  increase: 0,
  decrease: 1,
  bonuses: 2
};
